export const shouldBlockEntitlementRefresh = ({ background = false, hasAccess = false } = {}) => !background || !hasAccess;
export const shouldClearEntitlementsForError = (error) => [401, 403].includes(Number(error?.status));
